var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({
    'max-height': _vm.size + 'px',
    'max-width': _vm.size + 'px',
    height: '100%',
    width: '100%',
  }),attrs:{"src":_vm.url,"alt":"","referrerpolicy":"no-referrer","title":_vm.member.name,"height":_vm.size,"width":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }